import { Grid } from '@mui/material';

export const Bullets = ({ value, options }) => (
  <Grid item className="bullets" xs={12}>
    {value.split('\n').map((el) => (
      <p className="description" key={el.substring(0, 10)}>
        {el}
        <br />
      </p>
    ))}
    <div className="bullets">
      <ul>
        {options.split('\n').map((el) => (
          <li
            style={{ color: '#333', fontSize: '17px', lineHeight: '2.0625' }}
            key={el.substring(0, 10)}
          >
            {el}
          </li>
        ))}
      </ul>
    </div>
  </Grid>
);
